export class AuthModel {
  token: string;
  refreshToken: string;
  expiresIn: Date;

  setAuth(auth: AuthModel) {
    this.token = auth.token;
    this.refreshToken = auth.refreshToken;
    this.expiresIn = auth.expiresIn;
  }
}

export class UserDataModel{
  firstName: string;
  lastName: string;
  email:string;
}